// // router.js
// import { createRouter, createWebHistory } from 'vue-router';

// // 引入Vue组件
// import HelloWorld from './components/HelloWorld.vue'

// import MeiTuanProcess from './components/MeiTuanProcess.vue';
// import Binding from './components/binding.vue';

// // 定义路由
// const routes = [
//   { path: '/', component: HelloWorld },
//   { path: '/meituan', component: MeiTuanProcess },
//   { path: '/binding', component: Binding },
// ];

// // 创建router实例
// const router = createRouter({
//   history: createWebHistory(),
//   routes,
// });
// export default router;

import Vue from 'vue';
import Router from 'vue-router';
import Login from './components/login.vue';
import Verify from './components/verify.vue';
import Photo from './components/photo.vue';
Vue.use(Router);
const routes = [
  { path: '/', component: Login, meta: { title: '智洗科技' } },
  { path: '/Verify', component: Verify, meta: { title: '顺科智洗' } },
  { path: '/Camera', component: Photo, meta: { title: '顺科智洗' } },
];

export default new Router({
  mode: 'history', //后端支持可开
  // scrollBehavior: () => ({ y: 0 }),
  routes,
});
